var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beian"},[_vm._v("\n  ©2017 G9ZZ.  "),_c('a',{attrs:{"href":"https://github.com/g9zz","target":"_blank"}},[_vm._v(" 关于我们")]),_vm._v(" "),_c('a',{attrs:{"href":"http://www.beian.miit.gov.cn/","target":"_blank"}},[_vm._v("皖ICP备15017682号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94071dda","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = L9P9
// module chunks = 1